export default __webpack_public_path__ + "static/media/963hz-spiritual-guidance.fbe3fc5c.jpg";